import React, { ReactElement } from "react";

import classNames from "classnames";

import { IconInputApply } from "../icons/IconInputApply";
import { sparkInputNoLabelCSS, submitButton } from "./ChatInput.styles";
import TextInput from "../../text-input";
import { ChatInputProps } from "./ChatInput.types";

export const ChatInput = ({
  className,
  value,
  userHasNotAskedAnyQuestion,
  disabled,
  disabledSubmitButton,
  onChange,
  onSubmit,
  ...rest
}: ChatInputProps): ReactElement => {
  const handleKeyDown = (
    event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    if (event.key === "Enter") {
      onSubmit(value);
      onChange({ target: { value: "" } } as React.ChangeEvent<
        HTMLInputElement | HTMLTextAreaElement
      >);
    }
  };

  return (
    <TextInput
      placeholder={
        userHasNotAskedAnyQuestion ? "Ask me anything" : "Ask follow up"
      }
      name="chat-input"
      className={classNames("spark-mar-t-1", sparkInputNoLabelCSS, className)}
      value={value}
      onChange={onChange}
      onKeyDown={handleKeyDown}
      disabled={disabled}
      {...rest}
    >
      <button
        aria-label="Apply query"
        className={classNames("spark-btn--icon spark-icon", submitButton)}
        disabled={disabledSubmitButton}
        onClick={(): void => {
          onSubmit(value);
          onChange({ target: { value: "" } } as React.ChangeEvent<
            HTMLInputElement | HTMLTextAreaElement
          >);
        }}
      >
        <IconInputApply disabled={disabledSubmitButton} />
      </button>
    </TextInput>
  );
};
